<template src="./Calendario.html"></template>
<script>
import moment from "moment-timezone";
import Icono from "../Icono/Icono";
import SelectTree from "../SelectTree/SelectTree";
import {
  filtrosCalendario,
  eventosFiltrados,
  buscarPorCedula
} from "../../apiService/request/Calendario";
export default {
  data() {
    return {
      menu: false,
      documentoIngresado: "",
      eventosPaciente: {},
      opcionesFiltros: [],
      banderaMostrarSidebar: false,
      focus: "",
      today: moment()
        .tz("America/Bogota")
        .format("YYYY-MM-DD hh:mm:ss"),
      type: "month",
      typeToLabel: {
        month: "Mes",
        week: "Semana",
        day: "Dia",
        "4day": "4 Dias"
      },
      fechaInicial: Number(
        moment()
          .tz("America/Bogota")
          .startOf("month")
          .format("x")
      ),
      fechaFinal: Number(
        moment()
          .tz("America/Bogota")
          .endOf("month")
          .format("x")
      ),
      start: null,
      banderaRecolectarFiltros: false,
      end: null,
      selectedEvent: {},
      arrayPeticion: [
        { categoria: "responsable", data: [this.$store.state.provider_email] }
      ],
      selectedElement: null,
      selectedOpen: false,
      contadorArray: 0,
      arrayPeticionInicial: [
        { categoria: "responsable", data: [this.$store.state.provider_email] }
      ],
      eventos: [],
      events: [],
      filtros: [],
      card: 0,
      tarjetaCC: 0,
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1"
      ],
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party"
      ],
      iconoBot:
        "M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,2c8,0,14.9,4.7,18.1,11.5C36.1,7.7,29.4,4,22,4C14.6,4,7.9,7.7,3.9,13.5C7.1,6.7,14,2,22,2z M41.6,22C39.7,31.3,31.5,38,22,38S4.3,31.3,2.4,22C4.3,12.7,12.5,6,22,6S39.7,12.7,41.6,22z M22,42c-8,0-14.9-4.7-18.1-11.5C7.9,36.3,14.6,40,22,40c7.4,0,14.1-3.7,18.1-9.5C36.9,37.3,30,42,22,42z M13,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S16.3,16,13,16z M13,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S15.2,26,13,26z M31,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S34.3,16,31,16z M31,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S33.2,26,31,26z",
      iconoUsuario:
        "M22,44c-9.4,0-17-7.6-17-17c0-3.6,1.1-7.1,3.3-10c0.3-0.4,1-0.5,1.4-0.2c0.4,0.3,0.5,1,0.2,1.4C8,20.8,7,23.8,7,27c0,8.3,6.7,15,15,15s15-6.7,15-15c0-3.2-1-6.2-2.9-8.8c-0.3-0.4-0.2-1.1,0.2-1.4c0.4-0.3,1.1-0.2,1.4,0.2c2.1,2.9,3.3,6.4,3.3,10C39,36.4,31.4,44,22,44z M32,10c0-5.5-4.5-10-10-10S12,4.5,12,10s4.5,10,10,10S32,15.5,32,10z M30,10c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8S30,5.6,30,10z M44,0v44 M0,0v44",
      iconoServicio:
        "M40.5,35.1v-5c0-4.4-3.6-8-8-8s-8,3.6-8,8V36c0,3.3-2.7,6-6,6s-6-2.7-6-6V25.3C18.4,24.8,23,19.8,23,13.8V3.3c0-0.6-0.4-1-1-1h-3.7V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v4.7c0,0.6,0.4,1,1,1s1-0.4,1-1V4.3H21v9.5c0,5.2-4.3,9.5-9.5,9.5S2,19.1,2,13.8V4.3h2.7v1.3c0,0.6,0.4,1,1,1s1-0.4,1-1V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.3H1c-0.6,0-1,0.4-1,1v10.5c0,6,4.6,10.9,10.5,11.4V36c0,4.4,3.6,8,8,8s8-3.6,8-8v-5.8c0-3.3,2.7-6,6-6s6,2.7,6,6v5c-2,0.5-3.5,2.2-3.5,4.4c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5C44,37.4,42.5,35.6,40.5,35.1z M39.5,42c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S40.9,42,39.5,42z",
      iconoSede:
        "M43.7,20.1l-5.8-5.5c0,0,0,0,0,0L22.7,0.3c-0.4-0.4-1-0.4-1.4,0L6.1,14.6l0,0l-5.8,5.5c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l4.1-3.9V43c0,0.6,0.4,1,1,1h11.7c0.6,0,1-0.4,1-1V32.3h5V43c0,0.6,0.4,1,1,1h11.7c0.6,0,1-0.4,1-1V17.6l4.1,3.9c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3C44.1,21.1,44.1,20.5,43.7,20.1z M36.2,42h-9.7V31.3c0-0.6-0.4-1-1-1h-7c-0.6,0-1,0.4-1,1V42H7.8V15.8L22,2.4l14.2,13.4V42z M23,14v4.7h4.7v2H23v4.7h-2v-4.7h-4.7v-2H21V14H23z",
      iconoBuscar:
        "M17.8,27.8c0,0.6-0.4,1-1,1c-6.7,0-12.1-5.4-12.1-12.1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,5.6,4.5,10.1,10.1,10.1C17.3,26.8,17.8,27.3,17.8,27.8z M43.7,43.7C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L27.8,29.3c-3,2.6-6.8,4.2-11.1,4.2C7.5,33.5,0,26,0,16.8S7.5,0,16.8,0s16.8,7.5,16.8,16.8c0,4.3-1.6,8.1-4.2,11.1l14.4,14.4C44.1,42.7,44.1,43.3,43.7,43.7zM16.8,31.5c8.1,0,14.8-6.6,14.8-14.8S24.9,2,16.8,2S2,8.6,2,16.8S8.6,31.5,16.8,31.5z"
    };
  },
  computed: {
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }
      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? "" : endMonth;
      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? "" : endYear;
      const startDay = start.day;
      const endDay = end.day;
      switch (this.type) {
        case "month":
          return `${this.mayuculas(startMonth)} de ${startYear}`;
        case "week":
        case "4day":
          return `${this.mayuculas(
            startMonth
          )} ${startDay} a ${endDay} de ${startYear} `;
        case "day":
          return `${this.mayuculas(startMonth)} ${startDay} de ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long"
      });
    }
  },
  beforeUpdate() {},
  mounted() {
    this.$refs.calendar.checkChange();
  },
  created() {
    this.obtenerFiltrosCalendario();
    this.updateRange;
  },
  filters: {
    cambioMayuculas: function(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  components: {
    Icono,
    SelectTree
  },
  methods: {
    mayuculas: function(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    async obetenerFiltroPorCedula() {
      if (this.documentoIngresado != "") {
        try {
          this.$store.dispatch("setCargando", true);
          this.eventosPaciente = (
            await buscarPorCedula(this.documentoIngresado)
          ).data.data;
          if (this.eventosPaciente == "") {
            alert("No se han encontrado citas para el paciente");
          }
        } finally {
          this.$store.dispatch("setCargando", false);
        }
      } else {
        this.eventosPaciente = {};
      }
    },
    async obtenerEventosFiltrados(fechaInicial, fechaFinal, filtros) {
      try {
        this.$store.dispatch("setCargando", true);
        this.eventos = (
          await eventosFiltrados(fechaInicial, fechaFinal, filtros)
        ).data.data;
      } finally {
        this.banderaRecolectarFiltros = false;
        this.contadorArray = 0;
        this.$store.dispatch("setCargando", false);
      }
    },
    ObtenerValoresFiltros() {
      this.arrayPeticion = [];
      this.banderaRecolectarFiltros = true;
      this.banderaMostrarSidebar = false;
    },
    construirArrayPeticion(valor, index) {
      if (valor != null || valor != undefined) {
        this.arrayPeticion.push(valor);
      }
      this.contadorArray++;
      if (this.opcionesFiltros.length == this.contadorArray) {
        this.obtenerEventosFiltrados(
          this.fechaInicial,
          this.fechaFinal,
          this.arrayPeticion
        );
      }
    },
    async obtenerFiltrosCalendario() {
      this.opcionesFiltros = (await filtrosCalendario()).data.data;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },

    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    click() {
      this.showEvent;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;

        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
        this.card += 1;
      }
      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];
      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      this.fechaInicial = Number(
        moment(start.date)
          .tz("America/Bogota")
          .startOf("day")
          .format("x")
      );
      this.fechaFinal = Number(
        moment(end.date)
          .tz("America/Bogota")
          .endOf("day")
          .format("x")
      );
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);
      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);
        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: this.formatDate(first, !allDay),
          end: this.formatDate(second, !allDay),
          color: this.colors[this.rnd(0, this.colors.length - 1)]
        });
      }
      this.start = start;
      this.end = end;
      this.events = events;
      if (this.type == "4day") {
        this.obtenerEventosFiltrados(
          this.fechaInicial,
          this.fechaFinal - Number(86400000),
          this.arrayPeticion
        );
      } else {
        this.obtenerEventosFiltrados(
          this.fechaInicial,
          this.fechaFinal,
          this.arrayPeticion
        );
      }
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() +
            1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    }
  }
};
</script>
<style lang="scss" src="./Calendario.scss" scoped>
</style>
<style lang="scss" src="./Calendario.scss">
</style>


// WEBPACK FOOTER //
// src/components/Calendario/Calendario.vue